import { parseXYWH } from '@blocksuite/global/gfx';

import type { DatabaseInfo } from '../services/database-discovery';

const UNTITLED_DATABASE_TITLE = 'Untitled';

export interface DatabaseCanvasTarget {
  centerX: number;
  centerY: number;
}

function normalizeTitle(title: string): string {
  return title.trim().toLocaleLowerCase();
}

function getBaseDisplayTitle(database: DatabaseInfo): string {
  const title = database.databaseTitle.trim();
  return title.length > 0 ? title : UNTITLED_DATABASE_TITLE;
}

export function getWorkspaceDatabaseDisplayTitle(
  database: DatabaseInfo,
  siblings: DatabaseInfo[]
): string {
  const displayTitle = getBaseDisplayTitle(database);
  const normalized = normalizeTitle(displayTitle);
  if (normalized === normalizeTitle(UNTITLED_DATABASE_TITLE)) {
    return displayTitle;
  }

  const sameTitleCount = siblings.filter(
    sibling => normalizeTitle(getBaseDisplayTitle(sibling)) === normalized
  ).length;

  if (sameTitleCount <= 1) {
    return displayTitle;
  }

  return `${displayTitle} (${database.blockId.slice(0, 8)})`;
}

export function getWorkspaceDatabaseCanvasTarget(
  database: DatabaseInfo
): DatabaseCanvasTarget | null {
  if (!database.xywh) {
    return null;
  }

  const parsedXYWH = parseXYWH(database.xywh);
  if (!parsedXYWH) {
    return null;
  }

  const [x, y, width, height] = parsedXYWH;
  return {
    centerX: x + width / 2,
    centerY: y + height / 2,
  };
}

export function getWorkspaceDatabaseNavigationErrorMessage(
  database: DatabaseInfo
): string {
  const title = getBaseDisplayTitle(database);
  return `Could not jump to "${title}" on the canvas. The target block position is unavailable.`;
}
